/**
 * True on touch-first devices (iPad, POS tablets) where focusing an input pops
 * the OS keyboard. Keypad-enabled inputs use this to suppress the OS keyboard
 * (inputMode="none") and open the app's on-screen pad instead. Evaluated once —
 * the primary pointer type doesn't change mid-session.
 */
export const IS_COARSE_POINTER: boolean =
  typeof window !== 'undefined' &&
  typeof window.matchMedia === 'function' &&
  window.matchMedia('(pointer: coarse)').matches
